import { ActionTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { SohoModel } from '~/constants/SohoModel'
import { ApplicationsState, ApplicationResource, Application } from './applications.types'
import { setIncludedResources, formatRelationships } from '~/utils/store'

const actions: ActionTree<ApplicationsState, RootState> = {
  async fetchApplications ({ commit }) {
    const { data, meta, included } = await this.$sohoApi.get<ApplicationResource>(SohoModel.Application, { include: ['product', 'product.venue', 'attachments', 'submissions'] })

    commit('SET_APPLICATION_META', meta)

    if (included) {
      setIncludedResources(included, commit, {
        products: 'applications/products/SET_PRODUCT',
        attachments: 'applications/attachments/SET_ATTACHMENT',
        application_submissions: 'applications/submissions/SET_SUBMISSION'
      })
    }

    if ((data as ApplicationResource[]).length) {
      commit('SET_APPLICATIONS', data)

      return data
    }

    return null
  },

  async fetchApplication ({ commit }, id) {
    const { data, included } = await this.$sohoApi.get<ApplicationResource>(`${SohoModel.Application}/${id}`, { include: ['product', 'product.venue', 'attachments', 'submissions'] })

    if (included) {
      setIncludedResources(included, commit, {
        products: 'applications/products/SET_PRODUCT',
        attachments: 'applications/attachments/SET_ATTACHMENT',
        application_submissions: 'applications/submissions/SET_SUBMISSION'
      })
    }

    commit('SET_APPLICATION', data)

    return data
  },

  async createApplication({ commit }, type) {
    const { data } = await this.$sohoApi.post<Application>(SohoModel.Application, { type: SohoModel.Application, application_type: type })

    commit('SET_APPLICATION', data)

    return data
  },

  async updateApplication({ commit }, params) {
    const applicationParams = formatRelationships(params, { product: SohoModel.Product })

    const { data } = await this.$sohoApi.patch<Application>(SohoModel.Application, { type: SohoModel.Application, ...applicationParams }, undefined, true)

    commit('SET_APPLICATION', data)

    return data
  }
}

export default actions
